/* Kartograf · rimozione del fondo del logo, nostra, nel browser, senza librerie né licenze esterne.
   Pensata per loghi con fondo piatto (bianco o tinta unita):
   1) colore di fondo campionato in automatico dai bordi (fondo chiaro o fondo scuro a scelta)
   2) flood fill dai bordi con soglia regolabile: si toglie solo il fondo collegato al bordo,
      lo stesso colore DENTRO il logo resta
   3) bordi morbidi (fascia di 2 px + feather di 1 px) e defringe che toglie l'alone del fondo
*/
(function () {
  var KG = window.KG = window.KG || {};

  KG.canvasDa = function (img, max) {
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    var s = Math.min(1, (max || 1600) / Math.max(w, h));
    var c = KG.nuovoCanvas(Math.max(1, Math.round(w * s)), Math.max(1, Math.round(h * s)));
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c;
  };
  function lum(r, g, b) { return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255; }

  /* analizza il bordo: trasparente? uniforme? colore dominante, chiaro e scuro */
  KG.analizzaBordo = function (cv) {
    var w = cv.width, h = cv.height, d = cv.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
    var px = [], x, y, step = Math.max(1, Math.round((w + h) / 600));
    function add(x, y) { var k = (y * w + x) * 4; px.push([d[k], d[k + 1], d[k + 2], d[k + 3]]); }
    for (x = 0; x < w; x += step) { add(x, 0); add(x, 1); add(x, h - 1); add(x, h - 2); }
    for (y = 0; y < h; y += step) { add(0, y); add(1, y); add(w - 1, y); add(w - 2, y); }
    var trasp = px.filter(function (p) { return p[3] < 20; }).length / px.length;
    var op = px.filter(function (p) { return p[3] >= 20; });
    // colore dominante = cella più piena di un istogramma 3D a 16 livelli, poi media dei suoi pixel
    function dominante(lista) {
      if (!lista.length) return null;
      var celle = {}, best = null;
      lista.forEach(function (p) {
        var k = (p[0] >> 4) + ',' + (p[1] >> 4) + ',' + (p[2] >> 4), c = celle[k] || (celle[k] = { n: 0, r: 0, g: 0, b: 0 });
        c.n++; c.r += p[0]; c.g += p[1]; c.b += p[2]; if (!best || c.n > best.n) best = c;
      });
      return { col: [Math.round(best.r / best.n), Math.round(best.g / best.n), Math.round(best.b / best.n)], quota: best.n / lista.length };
    }
    var tutti = dominante(op), chiari = dominante(op.filter(function (p) { return lum(p[0], p[1], p[2]) >= 0.5; })),
      scuri = dominante(op.filter(function (p) { return lum(p[0], p[1], p[2]) < 0.5; }));
    var col = tutti ? tutti.col : [255, 255, 255];
    return {
      trasparente: trasp > 0.6, uniforme: !!tutti && tutti.quota > 0.8, col: col,
      modo: lum(col[0], col[1], col[2]) >= 0.5 ? 'chiaro' : 'scuro',
      chiaro: chiari ? chiari.col : null, scuro: scuri ? scuri.col : null
    };
  };

  /* toglie il fondo collegato ai bordi. opz: {col:[r,g,b], soglia: 4..120, dentro: bool} */
  KG.togliFondo = function (cv, opz) {
    var w = cv.width, h = cv.height, N = w * h, col = opz.col, tol = opz.soglia || 40;
    var out = KG.nuovoCanvas(w, h), oc = out.getContext('2d', { willReadFrequently: true });
    oc.drawImage(cv, 0, 0);
    var im = oc.getImageData(0, 0, w, h), d = im.data, i, p, x, y;
    // distanza dal colore di fondo (pixel già trasparenti = fondo)
    var dist = new Float32Array(N);
    for (p = 0; p < N; p++) {
      i = p * 4;
      if (d[i + 3] < 16) { dist[p] = 0; continue; }
      var dr = d[i] - col[0], dg = d[i + 1] - col[1], db = d[i + 2] - col[2];
      dist[p] = Math.sqrt((dr * dr + dg * dg + db * db) / 3);
    }
    // flood fill dai bordi
    var bg = new Uint8Array(N), st = new Int32Array(N), sp = 0;
    function push(q) { if (!bg[q] && dist[q] <= tol) { bg[q] = 1; st[sp++] = q; } }
    for (x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
    while (sp > 0) {
      p = st[--sp]; x = p % w; y = (p / w) | 0;
      if (x > 0) push(p - 1); if (x < w - 1) push(p + 1);
      if (y > 0) push(p - w); if (y < h - 1) push(p + w);
    }
    // opzione «Togli anche dentro le lettere»: svuota le zone CHIUSE del colore di fondo piccole
    // (meno del 2% dell'area del logo): i buchi di O, A, R se ne vanno, il centro di un anello grande resta
    if (opz.dentro) {
      var logoArea = 0; for (p = 0; p < N; p++) if (!bg[p]) logoArea++;
      var lim = Math.max(4, logoArea * 0.02), vis = new Uint8Array(N), comp = new Int32Array(N);
      for (var s0 = 0; s0 < N; s0++) {
        if (bg[s0] || vis[s0] || dist[s0] > tol) continue;
        var n = 0; sp = 0; st[sp++] = s0; vis[s0] = 1;
        while (sp > 0) {
          p = st[--sp]; comp[n++] = p; x = p % w; y = (p / w) | 0;
          if (x > 0 && !vis[p - 1] && !bg[p - 1] && dist[p - 1] <= tol) { vis[p - 1] = 1; st[sp++] = p - 1; }
          if (x < w - 1 && !vis[p + 1] && !bg[p + 1] && dist[p + 1] <= tol) { vis[p + 1] = 1; st[sp++] = p + 1; }
          if (y > 0 && !vis[p - w] && !bg[p - w] && dist[p - w] <= tol) { vis[p - w] = 1; st[sp++] = p - w; }
          if (y < h - 1 && !vis[p + w] && !bg[p + w] && dist[p + w] <= tol) { vis[p + w] = 1; st[sp++] = p + w; }
        }
        if (n < lim) for (var q = 0; q < n; q++) bg[comp[q]] = 1;
      }
    }
    // fascia di 2 px intorno al fondo tolto (solo lì si ammorbidisce: l'interno del logo resta pieno)
    var vic = new Uint8Array(N);
    for (p = 0; p < N; p++) if (bg[p]) vic[p] = 3;
    for (var giro = 2; giro >= 1; giro--) {
      var nuovi = [];
      for (p = 0; p < N; p++) {
        if (vic[p]) continue; x = p % w; y = (p / w) | 0;
        if ((x > 0 && vic[p - 1] > giro) || (x < w - 1 && vic[p + 1] > giro) || (y > 0 && vic[p - w] > giro) || (y < h - 1 && vic[p + w] > giro)) nuovi.push(p);
      }
      for (var j = 0; j < nuovi.length; j++) vic[nuovi[j]] = giro;
    }
    // alfa: fondo 0, fascia = rampa sulla distanza dal colore di fondo, resto 1
    var a = new Float32Array(N), morb = tol * 1.6 + 1;
    for (p = 0; p < N; p++) {
      if (bg[p]) a[p] = 0;
      else if (vic[p] && vic[p] < 3) a[p] = Math.max(0, Math.min(1, (dist[p] - tol) / (morb - tol)));
      else a[p] = 1;
      if (d[p * 4 + 3] < 255) a[p] *= d[p * 4 + 3] / 255;
    }
    // feather 1 px solo sul contorno
    var af = KG.boxBlur(a, w, h, 1);
    for (p = 0; p < N; p++) {
      i = p * 4;
      var al = a[p];
      if (bg[p]) al = 0;
      else if (vic[p]) al = Math.min(a[p], af[p] * 1.25);
      if (al > 0 && al < 1 && vic[p]) { // defringe: toglie il colore del fondo dal bordo semitrasparente
        var k = Math.max(al, 0.2);
        d[i] = Math.max(0, Math.min(255, (d[i] - col[0] * (1 - k)) / k));
        d[i + 1] = Math.max(0, Math.min(255, (d[i + 1] - col[1] * (1 - k)) / k));
        d[i + 2] = Math.max(0, Math.min(255, (d[i + 2] - col[2] * (1 - k)) / k));
      }
      d[i + 3] = Math.round(al * 255);
    }
    oc.putImageData(im, 0, 0);
    return out;
  };

  /* ritaglia i margini trasparenti, così il logo si centra da solo */
  KG.rifila = function (cv) {
    var w = cv.width, h = cv.height, d = cv.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) if (d[(y * w + x) * 4 + 3] > 12) {
      if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
    }
    if (x1 < 0) return cv;
    var p = Math.round(Math.max(w, h) * 0.01);
    x0 = Math.max(0, x0 - p); y0 = Math.max(0, y0 - p); x1 = Math.min(w - 1, x1 + p); y1 = Math.min(h - 1, y1 + p);
    var out = KG.nuovoCanvas(x1 - x0 + 1, y1 - y0 + 1);
    out.getContext('2d').drawImage(cv, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  };
})();
